import React from "react";

const InputError = ({ message }) => {
  return <p className="text-danger">* {message}</p>;
};

export default InputError;
